"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _pragma = require("../../../pragma");

var React = _interopRequireWildcard(require("react"));

var _axis = _interopRequireDefault(require("../../../asset/axis.svg"));

var _bhim = _interopRequireDefault(require("../../../asset/bhim.svg"));

var _googlePay = _interopRequireDefault(require("../../../asset/google-pay.svg"));

var _hdfc = _interopRequireDefault(require("../../../asset/hdfc.svg"));

var _indusInd = _interopRequireDefault(require("../../../asset/indus-ind.svg"));

var _netBanking = _interopRequireDefault(require("../../../asset/net-banking.svg"));

var _placeholder = _interopRequireDefault(require("../../../asset/placeholder.svg"));

var _smartTransfer = _interopRequireDefault(require("../../../asset/smart-transfer.svg"));

var _ = require("../..");

var css = _interopRequireWildcard(require("./ContainedIcon.style"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const logos = {
  axis: _axis.default,
  bhim: _bhim.default,
  gpay: _googlePay.default,
  hdfc: _hdfc.default,
  indusIND: _indusInd.default,
  netBanking: _netBanking.default,
  placeholder: _placeholder.default,
  smartTransfer: _smartTransfer.default
};

/**
 * ContainedIcon component is an icon contains one of predefined images or
 * provided children elements
 *
 * When a `ref` prop is provided, it will be forwarded to the root element. Any
 * other properties supplied will be provided to the root element (ie, the `as`
 * prop value). This includes all appropriate HTML attributes or aria tags.
 */
const ContainedIcon = /*#__PURE__*/React.forwardRef(({
  children,
  logo,
  variant = 'primary',
  withSmartlistIcon = false,
  backgroundColor,
  ...otherProps
}, ref) => {
  const logoSrc = typeof logo === 'string' ? logos[logo] : null;
  return (0, _pragma.createFelaElement)(_.View, _extends({
    alignItems: "center",
    css: css.wrapper,
    cssProps: {
      variant,
      backgroundColor
    },
    justifyContent: "center",
    ref: ref
  }, otherProps), withSmartlistIcon && (0, _pragma.createFelaElement)(_.View, {
    css: css.smartListIconWrapper,
    alignItems: "center",
    justifyContent: "center"
  }, (0, _pragma.createFelaElement)(_.FlashIcon, {
    color: "text.3",
    css: css.smartListFlashIcon
  })), children || logoSrc && (0, _pragma.createFelaElement)("img", {
    alt: "",
    css: css.image,
    src: logoSrc
  }));
});
ContainedIcon.displayName = 'ContainedIcon';
var _default = ContainedIcon;
exports.default = _default;
//# sourceMappingURL=ContainedIcon.js.map